const initialState = {
    isLoading   : false,
    products    : [],
    error       : null
};

export default initialState;
